export default {
  undeliverable: {
    en: 'Your subscription is paused on {date} due to the wrong shipping address. Please update your shipping address.',
  },
  getAccess: {
    en: 'Get access to hundreds of niche and designer fragrances and discover them monthly',
  },
  upgradeToPayPal: {
    en: 'Update to PayPal and get your next fragrance for just $13',
  },
  redeemText: {
    en: 'Discover hundreds of designer fragrances + delicious bath and body products, monthly!',
  },
  freePerfume: {
    en: 'FREE PERFUME FOR YOU AND YOUR FRIENDS',
  },
  freeCologne: {
    en: 'FREE COLOGNE FOR YOU AND YOUR FRIENDS',
  },
  getAFreeScent: {
    en: 'Get a free scent',
  },
  improve: {
    en: 'Improve',
  },
  redeemGift: {
    en: 'Redeem Gift',
  },
  redeemCoupon: {
    en: 'Redeem Coupon',
  },
  paymentProblem: {
    en: 'PAYMENT PROBLEM. YOUR CARD WAS DECLINED. PLEASE UPDATE YOUR BILLING INFO.',
  },
  helpUsToImprove: {
    en: 'Help us to improve Scentbird (& earn a free fragrance).',
  },
  loveToHear: {
    en: 'We would love to hear from you as we work to make our beauty & grooming even better.',
  },
  fragranceConcepts: {
    en: 'Please answer a few questions and vote on your favorite brand concepts',
  },
  improveRecommendations: {
    en: `
      <span class="text-bold">Improve your recommendations.</span>
      <span class="small-text">Let us know what fragrances you’ve already tried.</span>
    `,
  },
}
